<template>
  <div>
    <form-field-input
      label="Id"
      v-model="form.id"
      :validation-errors="validationErrors.id"
    ></form-field-input>

    <form-field-input
      label="Account Id"
      v-model="form.account_id"
      :validation-errors="validationErrors.account_id"
    ></form-field-input>

    <form-field-input
      label="Created At"
      v-model="form.created_at"
      :validation-errors="validationErrors.created_at"
    ></form-field-input>

    <form-field-input
      label="Created By"
      v-model="form.created_by"
      :validation-errors="validationErrors.created_by"
    ></form-field-input>

    <form-field-input
      label="Created By Type"
      v-model="form.created_by_type"
      :validation-errors="validationErrors.created_by_type"
    ></form-field-input>

    <form-field-input
      label="Updated At"
      v-model="form.updated_at"
      :validation-errors="validationErrors.updated_at"
    ></form-field-input>

    <form-field-input
      label="Updated By"
      v-model="form.updated_by"
      :validation-errors="validationErrors.updated_by"
    ></form-field-input>

    <form-field-input
      label="Updated By Type"
      v-model="form.updated_by_type"
      :validation-errors="validationErrors.updated_by_type"
    ></form-field-input>

    <form-field-input
      label="Deleted At"
      v-model="form.deleted_at"
      :validation-errors="validationErrors.deleted_at"
    ></form-field-input>

    <form-field-input
      label="Deleted By"
      v-model="form.deleted_by"
      :validation-errors="validationErrors.deleted_by"
    ></form-field-input>

    <form-field-input
      label="Deleted By Type"
      v-model="form.deleted_by_type"
      :validation-errors="validationErrors.deleted_by_type"
    ></form-field-input>

    <form-field-input
      label="Shareable Group Id"
      v-model="form.shareable_group_id"
      :validation-errors="validationErrors.shareable_group_id"
    ></form-field-input>

    <form-field-input
      label="Email Address"
      v-model="form.email_address"
      :validation-errors="validationErrors.email_address"
    ></form-field-input>

  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "ShareableGroupEmailForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
            id: '',
            account_id: '',
            created_at: '',
            created_by: '',
            created_by_type: '',
            updated_at: '',
            updated_by: '',
            updated_by_type: '',
            deleted_at: '',
            deleted_by: '',
            deleted_by_type: '',
            shareable_group_id: '',
            email_address: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    methods: {
      update() {
        return this.$api.shareableGroupEmails.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'ShareableGroupEmail was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        return this.$api.shareableGroupEmails.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'ShareableGroupEmail was created',
              type: 'is-success'
            });

            return res;
          })
        },
      delete() {
        return this.$api.shareableGroupEmails.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'ShareableGroupEmail was archived',
              type: 'is-success'
            });

            return res;
          });
      },
      restore() {
        return this.$api.shareableGroupEmails.restore(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'ShareableGroupEmail was restored',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
